import axios from 'axios';

const params = new URLSearchParams(window.location.search);
const opParam = params.get('op');
const storedOp = localStorage.getItem('op');

if (opParam !== null && opParam !== storedOp) {
  if (opParam === 'e') {
    localStorage.setItem('op', 'e');
  } else {
    localStorage.removeItem('op');
  }
}

export const isOpE = () => localStorage.getItem('op') === 'e';

export const getBaseUrl = () => (isOpE() ? process.env.REACT_APP_BASE_ETI : process.env.REACT_APP_BASE_URL);

export const getLoginUrl = () => (isOpE() ? process.env.REACT_APP_LOGIN_URL_ETI : process.env.REACT_APP_LOGIN_URL);

export const getSessionUrl = () => (isOpE() ? process.env.REACT_APP_SESSION_URL_ETI : process.env.REACT_APP_SESSION_URL);

const axiosClient = axios.create({
  baseURL: `${getBaseUrl()}`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});


axiosClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error.response;
    const lurl = getLoginUrl()
    if (res && res.status == 401) {
      localStorage.clear();
      window.location.href = lurl;
    }
    if (res && res.status == 500) {
      localStorage.clear();
      window.location.href = lurl;
    }
    console.error("Looks like there was a problem. Status Code: " + (res && res.status));
    return Promise.reject(error);
  }
);


export default axiosClient; 